/*
  Page Updaters :: Dropdown Updater Controllers

  Emits and event whenever its value changes

  EMITTED EVENTS
    update-success (document) Emitted when a new option is selected
      detail: {
        el:   the root element of this controller instance,
        ...details (the data attributes on the selected option)
      }
*/

import { createCustomEvent } from '../../../../javascript/shared/helpers';

export default class extends Controller {
  static targets = ['select'];

  connect() {
    App.DynamicSelect.onChange(this.selectTarget, this.emitChangeEvent.bind(this));
  }

  emitChangeEvent() {
    document.dispatchEvent(createCustomEvent('update-success', this.element, this.eventDetails))
  }

  //
  // GETTERS AND SETTERS
  //

  get eventDetails() {
    return this.selectedOption.dataset || {};
  }

  get selectedOption() {
    return this.selectTarget.querySelector(`option[value="${this.value}"]`) || {};
  }

  get value() {
    return App.DynamicSelect.getValue(this.selectTarget);
  }
};



// WEBPACK FOOTER //
// ./app/components/page_updaters/assets/javascript/page-updaters-dropdown-updater-controller.js